<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Auto Enrolment Questionnaire</h1>
    <p>To help us get your company set up with our payroll services, we’ve put together a quick questionnaire for you to share the details of your auto enrolment pension.</p>
    <p>For this this questionnaire we advise that you have access to your pension provider portal.
    </p>
  </div>


</template>


<script setup>

import { ref } from 'vue'

const error = ref(null)


const props = defineProps({
  formData: Object,
  clientInvite: Object
})


const validateStep = () => {
  return true;
}



const executeStep = async () => {
  return true;
}


defineExpose({ validateStep, executeStep });

</script>